import { render, staticRenderFns } from "./ServerPicker.vue?vue&type=template&id=5bcaf26b&"
import script from "./ServerPicker.vue?vue&type=script&lang=ts&"
export * from "./ServerPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports